<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/schedule/job/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('duilieming')">
						<el-input v-model="yt.conditions.queueName"></el-input>
					</el-form-item>
					<el-form-item :label="$t('renwuzhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.conditions.remark"></el-input>
          </el-form-item>

					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('chakanrizhi', scope.row, '70%')">{{$t('chakanrizhi')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-popconfirm title="确定立即执行?" confirm-button-text="开始执行" @confirm="runSchedule(scope.row)">
              <el-button type="text" slot="reference">
                {{$t('lijizhixing')}}
              </el-button>
            </el-popconfirm>
          </el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/schedule/job/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>

		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('xitongmokuaimingcheng')" required>
						<el-input v-model="yt.editObj.systemName"></el-input>
					</el-form-item>
          <el-form-item :label="$t('duilieming')" required>
            <el-input v-model="yt.editObj.queueName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cronbiaodashi')" required>
            <el-input v-model="yt.editObj.cronExpression"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')" required>
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.status">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>

          </el-form-item>

				</el-form>
				<template slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/schedule/job/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</template>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xitongmokuaimingcheng')" required>
            <el-input v-model="yt.editObj.systemName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('duilieming')" required>
            <el-input v-model="yt.editObj.queueName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cronbiaodashi')" required>
            <el-input v-model="yt.editObj.cronExpression"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')" required>
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.status">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
              <el-option :label="$t('zhixingzhong')" :value="2"></el-option>
            </el-select>
          </el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/schedule/job/update')" type="primary">
						{{$t('baocun')}}
					</el-button>

				</span>
			</template>


      <!-- 查看日志 -->
      <template v-if="yt.editObj.action == 'chakanrizhi'">
        <div class="dialog-scroller">
          <schedule_log :jobId="yt.editObj.id"></schedule_log>
        </div>
      </template>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import schedule_log from '@@/pages/admin/global/schedule/schedule_log'
	export default {
		name: 'admin_global_schedule_list',
		components: {
      schedule_log
		},
		data() {
			return {
				show: false,
				fildIds: '',
				timer: null,
				list: [],

				columns: [{
					label: 'xitongmokuaimingcheng',
					prop: 'systemName',
				}, {
					label: 'duilieming',
					prop: 'queueName',
				}, {
					label: 'cronbiaodashi',
					prop: 'cronExpression',
				}, {
					label: 'shifouqiyong',
					prop: 'status',
          type: 'bool',
          iln18: ['shi', 'fou']
				}, {
					label: 'beizhu',
					prop: 'remark'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 230,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc',
				}
				this.yt.get(1);
				this.utils.event_hub.$on('ADMIN_INFO_REFRESH', () => {
					this.yt.get(1);
				})
			}, 300)
		},
		destroyed() {
			clearTimeout(this.timer)
		},
		methods: {
      // 立即执行
      runSchedule(editObj) {
        this.http.post('/web/schedule/job/run', {
          id: editObj.id,
        }).then((res) => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        }).catch((msg) => {
          this.utils.errorMessage(msg);
        })
      },

		}
	};
</script>
